module.exports = __webpack_public_path__ + "img/sismica_3d_bacias.00437f32.png";